import React, { Component } from 'react';
import ExportComponent from '../../../../../../components/Export';

/**
 * Export screen, for showing export form.
 *
 * @extends React.Component
 */
class Export extends Component {
  render() {
    return (
      <ExportComponent />
    );
  }
}

export default Export;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Settings/screens/Export/index.js